<div class="mp-profile" *ngIf="dati">

  <div class="mp-user-card">
    <div class="mp-avatar-wrap">

      <div class="mp-avatar">
        <img
          *ngIf="dati.fotoProfiloUrl"
          [src]="dati.fotoProfiloUrl"
          class="mp-avatar-img">

        <span *ngIf="!dati.fotoProfiloUrl">
      {{ getInitials() }}
    </span>
      </div>

      <button
        type="button"
        class="mp-camera-btn"
        (click)="fileInput.click()">

        <i class="fa fa-camera"></i>

      </button>

      <button
        *ngIf="dati.id_immagine"
        type="button"
        class="mp-delete-avatar-btn"
        (click)="deleteFotoProfilo()">

        <i class="fa fa-trash"></i>

      </button>

      <input
        #fileInput
        type="file"
        accept="image/*"
        hidden
        (change)="onFotoProfiloSelected($event)">

    </div>

    <div class="mp-user-info">
      <h2>{{ dati.nomeNegozio }}</h2>

      <p>
        🛍️ {{ dati.citta }} · Membro dal {{ dati.membroDal }}
      </p>

      <div class="mp-badges">
        <span class="mp-badge success">✓ Verificato</span>
        <span class="mp-badge buyer">
          🛒 {{ dati.ruoloLabel }}
</span>
      </div>
    </div>

    <button
      class="mp-seller-btn"
      *ngIf="dati.stato === 89"
      (click)="richiediVenditore()">

      ✓ Richiedi abilitazione Venditore
      <span>GRATIS</span>

    </button>

    <span class="mp-seller-btn pending" *ngIf="dati.stato === 90">
  ⏳ Richiesta venditore in verifica
</span>

    <span class="mp-seller-btn" *ngIf="dati.stato === 91">
  ✓ Venditore abilitato
</span>

    <span class="mp-seller-btn blocked" *ngIf="dati.stato === 92">
  Venditore sospeso
</span>
  </div>

  <div class="mp-banner" *ngIf="!dati.isVenditore">
    <div class="mp-banner-icon">
      <i class="fa fa-box"></i>
    </div>

    <div class="mp-banner-content" >
      <h3>Inizia a vendere il tuo stock invenduto</h3>
      <p>
        Zero commissioni · Logistica Emme Evolution · Pagamenti mensili automatici · Flash Sales geolocalizzate
      </p>
    </div>

    <button *ngIf="dati.stato === 89"
    (click)="richiediVenditore()">Diventa Venditore →</button>
  </div>

  <div class="mp-tabs">
    <button [class.active]="tab === 'dati'" (click)="cambiaTab('dati')">
      <i class="fa fa-user"></i>
      Dati business
    </button>

    <!--<button [class.active]="tab === 'ordini'" (click)="cambiaTab('ordini')">
      <i class="fa fa-shopping-bag"></i>
      I miei ordini
    </button>-->

    <!--<button>
      <i class="fa fa-credit-card"></i>
      Fatture d'acquisto
    </button>-->
  </div>

<ng-container *ngIf="tabAttivo === 'dati'">

  <div class="mp-info-box">
     <span *ngIf="!editMode">
    I tuoi dati sono aggiornati.
  </span>

    <span *ngIf="editMode">
    Hai modificato i dati. Ricordati di salvare le modifiche.
  </span>

    <button
      *ngIf="!editMode"
      (click)="editClick()">

      <i class="fa fa-edit"></i>
      Modifica dati

    </button>

    <button
      *ngIf="editMode"
      class="mp-save-btn"
      (click)="saveClick()">


      Salva dati

    </button>
  </div>
  <section class="mp-card">
    <h3>
      <i class="fa fa-home"></i>
      Dati del negozio
    </h3>

    <div class="mp-grid">
      <div class="mp-field">
        <label>Nome negozio</label>
        <input [(ngModel)]="dati.nomeNegozio" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Ragione sociale</label>
        <input [(ngModel)]="dati.ragioneSociale" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Partita IVA</label>
        <input [(ngModel)]="dati.partitaIva" [disabled]="!editMode">
      </div>
      <div class="mp-field">
        <label>Codice fiscale</label>
        <input [(ngModel)]="dati.codiceFiscale" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>PEC</label>
        <input [(ngModel)]="dati.pec" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Codice SDI</label>
        <input [(ngModel)]="dati.codiceSdi" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Nome referente</label>
        <input [(ngModel)]="dati.nomeReferente" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Cognome referente</label>
        <input [(ngModel)]="dati.cognomeReferente" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Email</label>
        <input [(ngModel)]="dati.email" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Telefono</label>
        <input [(ngModel)]="dati.telefono" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Lingua</label>
        <select [(ngModel)]="dati.lingua" [disabled]="!editMode">
          <option>Italiano</option>
          <option>Inglese</option>
        </select>
      </div>
    </div>
  </section>

  <section class="mp-card">
    <h3>
      <i class="fa fa-map-marker-alt"></i>
      Indirizzo business
    </h3>

    <div class="mp-grid">
      <div class="mp-field full">
        <label>Indirizzo</label>
        <input [(ngModel)]="dati.indirizzo" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Città</label>
        <input [(ngModel)]="dati.citta" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>CAP</label>
        <input [(ngModel)]="dati.cap" [disabled]="!editMode">
      </div>

      <div class="mp-field">
        <label>Paese</label>
        <select [(ngModel)]="dati.paese" [disabled]="!editMode">
          <option>Italia</option>
        </select>
      </div>
    </div>
  </section>
  </ng-container>

  <ng-container *ngIf="tabAttivo === 'ordini'">
    <!--<app-campo-aggiuntivo [campo]="ordiniCrudField"></app-campo-aggiuntivo>-->
    <app-field-viewer [Campi]="campiAggiuntivi" [(Oggetto)]="dati" ></app-field-viewer>
  </ng-container>

</div>
